<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'角色管理'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">名称</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$hasAuthority(3700000,3701000,[3701001,3701004])" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div v-if="$validateAuthority(3700000,3701000,3701001)" class="div-btn cursor-el append-btn" @click="onShowAddGroup">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">创建角色</label>
            </div>
            <div v-if="$validateAuthority(3700000,3701000,3701004)" class="div-btn cursor-el append-btn" @click="onRefreshAuthority">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">权限刷新</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span v-if="$validateAuthority(3700000,3701000,3701003)" class="cursor-el" @click="onEditGroup(props.item)">编辑</span>
                <span v-if="$validateAuthority(3700000,3701000,3701002)" class="cursor-el" @click="onDelGroup(props.item.id, props.item.name)">删除</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import GroupAddLayer from "../layer/GroupAddLayer";
import GroupEditLayer from "../layer/GroupEditLayer";
import { getGroupItems, postDelGroup, postResetAuthority } from "../../common/api";

export default {
  name: "Groups",
  components: { TableBox, GroupAddLayer, GroupEditLayer },
  data() {
    return {
      action: getGroupItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "角色名称", name: "name", title: "name", isHtml: false, value: this.getObjValue },
        { state: true, alias: "上级角色", name: "parentName", title: "parentName", isHtml: false, value: this.getObjValue },
        { state: true, alias: "创建时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue },
        { state: true, alias: "创建人", name: "creator", title: "creator", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(3700000,3701000,[3701002,3701003]);
    },
    tableFieldNum() {
      let num = this.isOperation ? 1 : 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      return item[field];
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowAddGroup() {
      this.$layer.iframe({
        content: {
          content: GroupAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["800px", "600px"],
        title: "创建角色"
      });
    },
    onEditGroup(group) {
      this.$layer.iframe({
        content: {
          content: GroupEditLayer,
          parent: this,
          data: {
            groupInfo: group,
            refreshData: this.onReloadData
          }
        },
        area: ["800px", "600px"],
        title: "创建角色"
      });
    },
    onDelGroup(groupId, groupName) {
      this.$layer.confirm(`删除管理角色【${groupName}】？`, layerid => {
        postDelGroup({ groupId: groupId })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    },
    onRefreshAuthority() {
      postResetAuthority()
        .then(() => {
          this.$layer.msg("操作成功");
        })
        .catch(error => {
          if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
            this.$layer.msg(error.data.msg);
          } else {
            this.$layer.msg("操作失败");
          }
        });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 100px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>